const KEY = 'aventa_recent'
const MAX = 25

const ROUTE_MAP = [
    { pattern: /^\/dashboard$/,                    label: 'Dashboard',           type: 'home' },
    { pattern: /^\/projects\/create$/,             label: 'New project',         type: 'project' },
    { pattern: /^\/projects\/(\d+)\/edit$/,        label: 'Edit project',        type: 'project' },
    { pattern: /^\/projects\/(\d+)$/,              label: (m) => `Project #${m[1]}`, type: 'project' },
    { pattern: /^\/projects$/,                     label: 'Projects',            type: 'project' },
    { pattern: /^\/quotes\/create$/,               label: 'New quote',           type: 'quote' },
    { pattern: /^\/quotes\/(\d+)/,                 label: (m) => `Quote #${m[1]}`, type: 'quote' },
    { pattern: /^\/quotes$/,                       label: 'Quotes',              type: 'quote' },
    { pattern: /^\/clients\/create$/,              label: 'New client',          type: 'client' },
    { pattern: /^\/clients\/(\d+)/,                label: (m) => `Client #${m[1]}`, type: 'client' },
    { pattern: /^\/clients$/,                      label: 'Clients',             type: 'client' },
    { pattern: /^\/resources\/create$/,            label: 'New resource',        type: 'resource' },
    { pattern: /^\/resources\/(\d+)\/edit$/,       label: 'Edit resource',       type: 'resource' },
    { pattern: /^\/resources\/(\d+)$/,             label: (m) => `Resource #${m[1]}`, type: 'resource' },
    { pattern: /^\/resources$/,                    label: 'Resources',           type: 'resource' },
    { pattern: /^\/profile$/,                      label: 'My profile',          type: 'profile' },
    { pattern: /^\/options\/security/,             label: 'Security settings',   type: 'settings' },
    { pattern: /^\/options\/finance/,              label: 'Finance settings',    type: 'settings' },
    { pattern: /^\/options\/general/,              label: 'General settings',    type: 'settings' },
    { pattern: /^\/options\/customization/,        label: 'Customization',       type: 'settings' },
    { pattern: /^\/options/,                       label: 'Settings',            type: 'settings' },
    { pattern: /^\/vendor\/jobs\/offers\/(\d+)/,   label: 'Job offer',           type: 'job' },
    { pattern: /^\/vendor\/jobs\/(\d+)/,           label: (m) => `Job #${m[1]}`, type: 'job' },
    { pattern: /^\/vendor/,                        label: 'Vendor portal',       type: 'vendor' },
]

export const resolveRoute = (pathname) => {
    for (const r of ROUTE_MAP) {
        const m = pathname.match(r.pattern)
        if (m) return {
            label: typeof r.label === 'function' ? r.label(m) : r.label,
            type: r.type,
        }
    }
    return { label: pathname, type: 'link' }
}

export const getRecentItems = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]') } catch { return [] }
}

export const pushRecentItem = (pathname) => {
    if (pathname === '/login') return
    const { label, type } = resolveRoute(pathname)
    const item = { path: pathname, label, type, ts: Date.now() }
    const existing = getRecentItems().filter(i => i.path !== pathname)
    existing.unshift(item)
    localStorage.setItem(KEY, JSON.stringify(existing.slice(0, MAX)))
}

export const clearRecentItems = () => localStorage.removeItem(KEY)
